import Vue from 'vue';
import Vuex from 'vuex';

import cacheAction from '../../../assets/plugin/cacheActions';
import user from './modules/modules_user';
import student from './modules/modules_student';
import points from './modules/modules_points';
import handout from './modules/modules_handout';
import prepare from './modules/modules_prepare';
import resource from './modules/modules_resource';
import courseLog from './modules/modules_courseLog';
import homework from './modules/modules_homework';
import courseware from './modules/modules_courseware';
import democlass from './modules/modules_democlass';
import evaluation from './modules/modules_evaluation';
import config from './modules/modules_config';
import message from './modules/modules_message';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        student,
        points,
        handout,
        prepare,
        resource,
        courseLog,
        homework,
        courseware,
        democlass,
        evaluation,
        config,
        message
    },
    plugins: [cacheAction]
});



// WEBPACK FOOTER //
// ./src/views/index/store/index.js